import { OPCO_ID } from '@/models/opco/opco.shared.types';
import getEnvironmentVariable from '../../utils/get-environment-variable';
import { Config } from './glp.types';

const totalRewardOpcos: Record<OPCO_ID, boolean> = {
  [OPCO_ID.AVIOS]: false,
  [OPCO_ID.IB]: true,
  [OPCO_ID.BAEC]: false,
  [OPCO_ID.EIC]: false,
  [OPCO_ID.IBP]: true,
  [OPCO_ID.VYC]: true,
};

const getGlpConfig = (opco: OPCO_ID): Config => ({
  BASE_URL: getEnvironmentVariable('GLP_BASE_URL'),
  FETCH_TOTAL_REWARD: totalRewardOpcos[opco],
});

export default getGlpConfig;
